import { createFileRoute } from "@tanstack/react-router";
import AdminSeedDataDetailPage from "@/admin/pages/seed-data-detail";

export const Route = createFileRoute("/admin/seed-data/$type")({
  component: AdminSeedDataDetailPage,
});
